<template>
  <x-page
    :loading="loading"
    :no-back="true"
    :title-adaptive="true"
    :transparent-header="true"
    :enable-header-parallax="true"
    :close-on-back="true"
  >
    <template v-if="!loading" #header="{ headerParallaxRate, handleBackClick }">
      <div
        :class="[_.header, headerParallaxRate > 0 && _.header2]"
        :style="{
          '--scroll-ratio': headerParallaxRate,
        }"
      >
        <!-- 返回 -->
        <x-icon
          v-if="!isEmbed"
          name="back"
          :class="_.back"
          @click="handleBackClick"
        />
        <!-- LOGO -->
        <!-- <div :class="_.logo" /> -->
        <!-- <div :class="_.grow"></div> -->
        <!-- 搜索 -->
        <div
          v-if="searchData"
          v-track="{
            name: '点击搜索栏',
            id: '0b23bd64-c6e0-4902-b222-f43c4b141f95',
            newId: 'SouSuoLan',
            extra: {
              search_scene_id: searchData.id,
            },
          }"
          :class="_.search"
          @click="handleSearchClick"
        >
          <div :class="_.icon">
            <x-icon name="search" />
          </div>
          <div :class="_.text">{{ searchData.defaultKeyWord }}</div>
        </div>
        <!-- 个人中心 -->
        <div
          v-if="isEmbed"
          v-track="{
            name: '个人中心',
            id: 'b7c273dc-6aaf-4372-822f-388d611845ef',
          }"
          :class="_.user"
          @click="handleUserClick"
        >
          <img :src="require('./images/用户.png')" :class="_.icon" />
        </div>
      </div>
    </template>
    <template v-if="!loading">
      <!-- 头图 -->
      <div :class="_.headImage" />

      <div :class="_.main">
        <!-- 容器 -->
        <div :class="_.container">
          <!-- 轮播 -->
          <van-swipe
            v-if="homeData.轮播.length"
            :class="_.banner"
            :autoplay="5000"
          >
            <van-swipe-item
              v-for="(item, index) in homeData.轮播"
              :key="item.id"
              v-track="{
                name: '轮播',
                id: 'cleweqx1r0004vprl48rw7lb5',
                newId: 'LunBo',
                resource: item,
                index: index,
                extra: {
                  url: item.targetUrl,
                  banner_name: item.title,
                  banner_id: item.id,
                },
              }"
              :class="_.item"
              @click="$handleResourceClick(item, '首页轮播')"
            >
              <van-image :src="item.icon" fit="cover" :class="_.cover" />
            </van-swipe-item>
          </van-swipe>

          <!-- 政府补贴 -->
          <div
            v-if="homeData.政府补贴 && homeData.政府补贴.length"
            :class="_.subsidy"
            @click="$handleResourceClick(homeData.跳转配置[0], '政府补贴')"
          >
            <div :class="_.scroll">
              <div :class="_.con">
                <div
                  v-for="item in homeData.政府补贴"
                  :key="item.id"
                  v-track="{
                    name: '点击政府补贴',
                    newId: 'dian_ji_zheng_fu_bu_tie',
                    extra: {
                      bu_tie_id: item.id,
                      bu_tie_ming_cheng: item.title,
                      track_code: 'a280d488768d4800a81c4ac98bcf7250',
                    },
                  }"
                  :class="_.item"
                  @click="$handleResourceClick(item, '政府补贴')"
                >
                  <img :class="_.img" :src="item.icon" />
                </div>
              </div>
            </div>
          </div>
          <!-- 市场消费券 -->
          <div
            v-if="homeData.市场消费券 && homeData.市场消费券.length"
            :class="_.consume"
            @click="$handleResourceClick(homeData.跳转配置[1], '市场消费券')"
          >
            <div :class="_.con">
              <div
                v-for="item in homeData.市场消费券"
                :key="item.id"
                v-track="{
                  name: '点击市场消费券',
                  newId: 'dian_ji_shi_chang_xiao_fei_quan',
                  extra: {
                    xiao_fei_quan_id: item.id,
                    xiao_fei_quan_ming_cheng: item.title,
                    track_code: 'aec93b3d9e464d92b3ef5b77b414a97a',
                  },
                }"
                :class="_.item"
                @click="$handleResourceClick(item, '市场消费券')"
              >
                <img :class="_.img" :src="item.icon" />
              </div>
            </div>
          </div>

          <div
            v-if="homeData.周末老字号 && homeData.周末老字号.length"
            :class="_.activity"
          >
            <div :class="_.old">
              <div :class="_.title">
                <img :class="_.logo" src="./images/周末老字号.png" alt="" />
                <span
                  @click="
                    $handleResourceClick(
                      homeData.周末老字号_清库存_查看更多[0],
                      '周末老字号_查看更多',
                    )
                  "
                  >查看更多<img src="./images/arrow.png" alt=""
                /></span>
              </div>
              <div :class="_.list">
                <div
                  v-for="item in homeData.周末老字号"
                  :key="item.id"
                  v-track="{
                    name: '点击周末老字号',
                    newId: 'dian_ji_zhou_mo_lao_zi_hao',
                    extra: {
                      shang_pin_ming_cheng: item.title,
                      shang_pin_id: item.id,
                      track_code: '695e568bf4904edd9537ffd81c1daea6',
                    },
                  }"
                  :class="_.item"
                  @click="$handleResourceClick(item, '周末老字号')"
                >
                  <img :src="item.icon" alt="" />
                  <div :class="_.text">
                    <p>{{ item.title }}</p>
                    <div :class="_.amount">
                      <span><font>￥</font>{{ item.discountAmt }}</span>
                      <del v-if="item.amt">￥{{ item.amt }}</del>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div :class="_.clear">
              <div :class="_.title">
                <img :class="_.logo" src="./images/清库存.png" alt="" />
                <span
                  @click="
                    $handleResourceClick(
                      homeData.周末老字号_清库存_查看更多[1],
                      '周末老字号_查看更多',
                    )
                  "
                  >查看更多<img src="./images/arrow.png" alt=""
                /></span>
              </div>
              <div :class="_.sign">
                {{
                  homeData.周末老字号_清库存_查看更多 &&
                  homeData.周末老字号_清库存_查看更多[2] &&
                  homeData.周末老字号_清库存_查看更多[2].title
                }}
              </div>
              <div :class="_.list">
                <div
                  v-for="item in homeData.清库存"
                  :key="item.id"
                  v-track="{
                    name: '点击清库存',
                    newId: 'dian_ji_qing_ku_cun',
                    extra: {
                      shang_pin_id: item.id,
                      shang_pin_ming_cheng: item.title,
                      track_code: 'ec08fa41bf4b40fa83bb572ba6aec4d8',
                    },
                  }"
                  :class="_.item"
                  @click="$handleResourceClick(item, '清库存')"
                >
                  <img :src="item.icon" alt="" />
                  <div :class="_.text">
                    <p>{{ item.title }}</p>
                    <div :class="_.amount">
                      <div :class="_.price">
                        <span :class="_.des">超值价</span>
                        <span :class="_.amt"
                          ><font>￥</font>{{ item.discountAmt }}</span
                        >
                      </div>
                      <div v-if="item.amt" :class="_.dashPrice">
                        <span :class="_.amt"
                          ><font>￥</font
                          >{{ Math.floor(item.amt - item.discountAmt) }}</span
                        >
                        <span :class="_.des">直降</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 特色专场 -->
          <div :class="_.cert">
            <x-grid :class="_.list" :col-count="2" :gap="0.5">
              <div
                v-for="item in homeData.特色专场"
                :key="item.id"
                v-track="{
                  name: '特色专场',
                  newId: 'te_se_zhuan_chang',
                  extra: {
                    zhuan_chang_lei_xing: item.title,
                    shang_pin_id: item.id,
                    track_code: 'bdb752d057ec4b1d883b346690457419',
                  },
                }"
                :class="_.item"
                @click="$handleResourceClick(item, '首页特色专场')"
              >
                <img :class="_.title" :src="item.icon" alt="" />
                <template v-if="item.imgList && item.imgList.length">
                  <div
                    v-for="(img, index) in item.imgList"
                    :key="index"
                    :class="_.section"
                    @click.stop="
                      $handleResourceClick(img, '首页特色专场_商品列表')
                    "
                  >
                    <img :src="img.icon" alt="" />
                    <p>
                      <span :class="_.amt"
                        ><span>￥</span>{{ Math.floor(img.discountAmt) }}</span
                      >
                      <br v-if="img.amt > 0" />
                      <s v-if="img.amt > 0" :class="_.dashPrice"
                        >￥{{ Math.floor(img.amt) }}</s
                      >
                    </p>
                  </div>
                </template>
              </div>
            </x-grid>
          </div>

          <!-- 热门推荐 -->
          <div
            v-if="
              homeData.热门推荐_推荐商品.length &&
              homeData.热门推荐_活动瓷片.length >= 2
            "
            :class="_.recommend"
          >
            <div :class="_.hd">
              <img src="./images/精选好物.png" alt="" /><span
                >低价格 高品质</span
              >
            </div>
            <div :class="_.bd">
              <van-swipe :class="_.left" :autoplay="5000">
                <van-swipe-item
                  v-for="item in homeData.热门推荐_推荐商品"
                  :key="item.id"
                  v-track="{
                    name: '热门推荐_爆款推荐',
                    newId: 'shou_ye_re_men_tui_jian',
                    extra: {
                      tui_jian_lei_xing: '爆款推荐',
                      chan_pin_wei_zhi: 1,
                      shang_pin_id: item.id,
                      track_code: 'f0db3c64c09d45de986a422fd5c908f8',
                    },
                  }"
                  :class="_.item"
                  @click="$handleResourceClick(item, '首页热门推荐_爆款推荐')"
                >
                  <img src="./images/热销.png" :class="_.badge" />
                  <van-image :src="item.icon" fit="cover" :class="_.cover" />
                  <div :class="_.content">
                    <div v-if="item.sales" :class="_.views">
                      <img src="./images/热.png" :class="_.icon" />{{
                        item.sales
                      }}
                    </div>
                    <div :class="_.title">
                      {{ item.title }}
                    </div>
                    <div :class="_.price">
                      <div :class="_.current">
                        <span>￥</span>{{ item.discountAmt }}
                      </div>
                      <div
                        v-if="+item.amt && +item.amt !== +item.discountAmt"
                        :class="_.cost"
                      >
                        <span>￥</span>{{ item.amt }}
                      </div>
                    </div>
                  </div>
                </van-swipe-item>
              </van-swipe>

              <div :class="_.right">
                <img
                  v-for="item in homeData.热门推荐_活动瓷片"
                  :key="item.id"
                  v-track="{
                    name: '热门推荐_攻略内容',
                    newId: 'shou_ye_re_men_tui_jian',
                    extra: {
                      tui_jian_lei_xing: '攻略内容',
                      chan_pin_wei_zhi: 3,
                      shang_pin_id: item.id,
                      track_code: 'f0db3c64c09d45de986a422fd5c908f8',
                    },
                  }"
                  :src="item.icon"
                  :class="_.bottom"
                  @click="$handleResourceClick(item)"
                />
              </div>
            </div>
          </div>

          <!-- 更多商品 -->
          <div :class="_.waterfall">
            <!-- <div :class="_.title">更多好物</div> -->
            <x-waterfall :load="handleLoad" no-complete-tips>
              <template #default="{ data }">
                <x-masonry :class="_.list" :col-count="2" :gap="12">
                  <div
                    v-for="(item, index) in data"
                    :key="index"
                    v-track="{
                      name: '热门推荐_更多商品',
                      newId: 'shou_ye_re_men_tui_jian',
                      extra: {
                        tui_jian_lei_xing: '更多商品',
                        chan_pin_wei_zhi: 4,
                        shang_pin_id: item.id || '',
                        track_code: 'f0db3c64c09d45de986a422fd5c908f8',
                      },
                    }"
                    :class="_.item"
                    @click="$handleResourceClick(item, '首页更多商品')"
                  >
                    <x-square>
                      <img :src="item.icon" :class="_.cover" />
                    </x-square>
                    <div :class="_.content">
                      <div :class="_.name">
                        {{ item.title }}
                      </div>
                      <div v-if="item.tags && item.tags.length" :class="_.tags">
                        <div v-for="tag in item.tags" :key="tag" :class="_.tag">
                          {{ tag }}
                        </div>
                      </div>
                      <div :class="_.extra">
                        <div :class="_.price">
                          <span>￥</span>{{ item.discountAmt }}
                        </div>
                        <div v-if="item.sales" :class="_.sales">
                          销量 {{ item.sales }}
                        </div>
                      </div>
                    </div>
                  </div>
                </x-masonry>
              </template>
            </x-waterfall>
          </div>
        </div>
      </div>

      <!-- 购物车 -->
      <x-float-cart v-if="isEmbed" style2 />

      <!-- 广告弹窗 -->
      <van-popup
        v-model="adDialogVisible"
        position="center"
        get-container=".__app__"
        :class="_.adDialog"
        @closed="handleAdDialogClosed"
      >
        <img
          v-track="{
            name: '广告弹窗',
            id: '9f0f3dc3-d1de-4f1c-94a7-7048b3e7ff69',
            resource: adDialogData,
          }"
          :src="adDialogData.icon"
          :class="_.cover"
          @click="handleAdDialogClick"
        />
        <img
          :src="require('./images/关闭.png')"
          :class="_.close"
          @click="adDialogVisible = false"
        />
      </van-popup>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiPageConfigDecorateGetData,
    apiPageConfigDecorateSearchData,
    apiPageConfigGetStateContentByApp,
    apiPageConfigUserLabel,
    apiSearchMartSearchFindSceneDetail,
  } from '@/api'
  import { currentMall } from '@/mall'
  import { dcb } from '@dcb/jssdk'
  import { devOrProd, prepareData, pxToRem, requiredDeep } from '@/utils'
  import { formatDate } from 'vtils/date'
  import { fromPairs, LocalStoragePlus } from 'vtils'
  import { globalModel } from '@/model'
  import { navigateTo } from '@/router'
  import { pageBridge } from '@/components'

  const adDialogResourcePositionId = devOrProd(
    '8aaa8fcd7e6c335e017e76adde930084',
    '8aaab8d17e72d56b017e768a6bd70018',
  )

  const ResourcePositionId = devOrProd(
    '8aaa8f8e8971d4b70189afea4c26013f',
    '8aaa8f8e8971d4b70189afea4c26013f',
  )

  const adDialogCountStorage = new LocalStoragePlus({
    key: 'home_ad_dialog',
  })
  const currentDate = formatDate(new Date(), 'yyyy-mm-dd')

  let adDialogDisplayed = false

  export default Vue.extend({
    props: {
      pageHdHeight: {
        type: Number,
        required: true,
      },
    },

    data: () => ({
      // 页面级加载状态
      loading: true,

      // 用户数据
      userData: {},

      // 首页数据
      homeData: {},

      // 搜索数据
      searchData: {},

      // 分类索引
      categoryIndex: 0,

      // 是否内嵌
      isEmbed: globalModel.state.isEmbed,

      // 弹窗数据
      adDialogData: {},

      //多慧玩-多多客服数据
      consultData: [],

      // 是否显示广告弹窗
      adDialogVisible: false,
    }),

    mounted() {
      this.$track.push({
        name: '浏览消费券首页',
        newId: 'liu_lan_xiao_fei_quan_shou_ye',
        extra: {
          track_code: '8169bd5aa9404ddfaeda5a03e8d2a2f4',
        },
      })

      if (!adDialogDisplayed) {
        // 获取广告弹窗数据
        apiPageConfigGetStateContentByApp({
          stateId: adDialogResourcePositionId,
          pageIndex: 1,
          pageSize: 1,
        }).then(res => {
          if (res.list.length) {
            // 广告数据
            const ad = res.list[0]

            // 最大展示次数
            const max = Number(ad.remarkMap.display_times || 0)
            // 当前展示次数
            const current =
              adDialogCountStorage.get({
                tag: currentDate,
              }) ?? 0

            // 仅当前展示次数小于最大展示次数时显示广告
            if (current < max) {
              this.adDialogData = ad
              this.adDialogVisible = true
            }
          }
        })
      }

      //获取多慧玩-多多客服数据
      apiPageConfigGetStateContentByApp({
        stateId: ResourcePositionId,
        pageIndex: 1,
        pageSize: 20,
      }).then(res => {
        this.consultData = res.list
      })

      pageBridge.on('scroll', ({ scrollTop }) => {
        if (scrollTop > 200) {
          globalModel.update({
            homeTabCanBackTop: true,
          })
        } else {
          globalModel.update({
            homeTabCanBackTop: false,
          })
        }
      })
    },

    activated() {
      this.prepareData()
    },

    beforeDestroy() {
      globalModel.update({
        homeTabCanBackTop: false,
      })
    },

    methods: {
      pxToRem: pxToRem,

      // 准备数据
      async prepareData() {
        // 非 cdn 接口不影响主流程
        apiSearchMartSearchFindSceneDetail({
          sceneId: currentMall.mall_home_search_scene_id,
        }).then(searchData => {
          this.searchData = searchData
        })

        const { userData, homeData } = await prepareData({
          userData: apiPageConfigUserLabel(),
          homeData: Promise.all(
            [
              '多多商城-消费券首页-轮播',
              '多多商城-消费券首页-政府补贴',
              '多多商城-消费券首页-市场消费券',
              '多多商城-消费券首页-周末老字号',
              '多多商城-消费券首页-清库存',
              '多多商城-消费券首页-周末老字号_清库存_查看更多',
              '多多商城-消费券首页-热门推荐_推荐商品',
              '多多商城-消费券首页-热门推荐_活动瓷片',
              '多多商城-消费券首页-特色专场',
              '多多商城-消费券首页-特色专场_商品列表',
              '多多商城-消费券首页-跳转配置',
            ].map(async id => [
              id.replace('多多商城-消费券首页-', '').replace(/-/g, '_'),
              await apiPageConfigDecorateSearchData(
                {
                  id: id,
                  pageIndex: 1,
                  pageSize: 100,
                },
                {
                  name: id,
                },
              )
                .then(requiredDeep)
                .then(res => res.list),
            ]),
          ).then(res => fromPairs(res)),
        })

        this.userData = userData

        await Promise.all(
          homeData.特色专场_商品列表.map(async ({ stateName, id }, index) => [
            await apiPageConfigDecorateGetData(
              {
                id: '多多商城-消费券首页-特色专场_商品列表',
                innerId: id,
                pageIndex: 1,
                pageSize: 2,
              },
              {
                name: stateName,
              },
            )
              .then(requiredDeep)
              .then(res => res.list)
              .then(
                res =>
                  res.length &&
                  (homeData.特色专场[index].imgList = res.slice(0, 2)),
              ),
          ]),
        )

        this.homeData = homeData

        this.loading = false
      },

      // 点击搜索
      handleSearchClick() {
        navigateTo('SearchEntry', {
          q: this.searchData.defaultKeyWord,
          l: JSON.stringify(/* this.searchData.refCategoryIds */ []),
        })
      },

      // 点击用户
      handleUserClick() {
        navigateTo('UserIndex')
      },

      // 点击商品分类
      handleCategoryClick() {
        navigateTo('CategoryIndex')
      },

      // 广告弹窗点击
      handleAdDialogClick() {
        this.adDialogVisible = false
        this.$nextTick(() => this.$handleResourceClick(this.adDialogData))
      },

      // 广告弹窗关闭
      handleAdDialogClosed() {
        adDialogDisplayed = true
        adDialogCountStorage.set(count => (count ?? 0) + 1, {
          tag: currentDate,
        })
      },

      toConsult() {
        dcb.navigateTo({
          url: this.consultData[0].targetUrl,
        })
      },

      handleLoad({ pageNumber }) {
        return apiPageConfigDecorateSearchData(
          {
            id: '多多商城-消费券首页-热门推荐_更多商品',
            pageIndex: pageNumber,
            pageSize: 10,
          },
          {
            name: '多多商城-消费券首页-热门推荐_更多商品',
          },
        )
      },
    },
  })
</script>

<style lang="scss" module>
  .header {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 12px;
    box-sizing: border-box;

    .back {
      flex-shrink: 0;
      font-size: 18px;
      color: white;
      margin-right: 8px;

      &:active {
        opacity: 0.8;
      }
    }

    .logo {
      margin-right: 16px;
      width: 97px;
      height: 25px;
      background-image: url('./images/多多商城.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .grow {
      flex-grow: 1;
    }

    .search {
      // width: 132px;
      flex: 1;
      height: 32px;
      background: #ff8283;
      color: #ffffff;
      border-radius: 100px;
      display: flex;
      align-items: center;
      padding-left: 8px;
      box-sizing: border-box;

      .icon {
        flex-shrink: 0;
        font-size: 18px;
      }

      .text {
        margin-left: 6px;
        font-size: 14px;
        line-height: 20px;
      }
    }

    .user {
      margin-left: 15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .icon {
        width: 26px;
        height: 26px;
      }

      &:active {
        opacity: 0.9;
      }
    }

    &.header2 {
      background-color: rgba(white, var(--scroll-ratio));

      .back {
        color: rgba(black, var(--scroll-ratio));
      }

      .logo {
        background-image: url('./images/多多严选2.png');
        opacity: var(--scroll-ratio);
      }

      .search {
        background-color: rgba(#f5f5f5, var(--scroll-ratio));
        color: rgba(#999999, var(--scroll-ratio));
      }
    }
  }

  .headImage {
    position: relative;
    width: 100%;
    height: 390px;
    background-image: url('./images/头图.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .test {
    height: 1000px;
  }

  .main {
    position: relative;
    margin-top: calc(var(--page-header-height) - 390px + 12px);
    font-size: 0;

    .container {
      background: linear-gradient(
        180deg,
        #ffffff 0%,
        #f5f5f5 50px,
        #f5f5f5 340px,
        #f5f5f5 100%
      );
      border-radius: 12px 12px 0px 0px;
      // padding: 12px;
      padding: 12px 0;

      .banner {
        margin: 0 12px 12px;
        // height: 100px;
        aspect-ratio: 351/100;
        border-radius: 8px;
        overflow: hidden;

        .cover {
          width: 100%;
          // height: 100px;
          aspect-ratio: 351/100;

          img {
            border-radius: 8px;
          }
        }

        :global {
          .van-swipe__indicators {
            bottom: 8px;

            .van-swipe__indicator {
              width: 4px;
              height: 4px;
              border-radius: 4px;
              background: rgba(#ffffff, 0.6);

              &.van-swipe__indicator--active {
                width: 8px;
                height: 4px;
                background: #ff1c20;
              }
            }
          }
        }
      }

      .subsidy {
        margin: 0 12px 12px;
        background: url('./images/政府补贴.png');
        background-size: 100% 100%;
        height: 185px;

        padding-top: 58px;
        padding-left: 11px;
        box-sizing: border-box;
        .scroll {
          overflow-x: scroll;
          &::-webkit-scrollbar {
            display: none;
          }
          .con {
            display: flex;
            .item {
              width: 130px;
              height: 118px;
              margin-right: 8px;
              img {
                width: 130px;
                height: 118px;
                border-radius: 12px;
                object-fit: cover;
              }
            }
          }
        }
      }

      .consume {
        margin: 0 12px 12px;
        background: url('./images/市场消费券.png');
        background-size: 100% 100%;
        height: 182px;
        padding: 53px 8px 12px;
        box-sizing: border-box;

        .con {
          display: flex;
          .item {
            width: 106px;
            height: 117px;
            &:not(:last-child) {
              margin-right: 8px;
            }
            img {
              width: 106px;
              height: 117px;
              border-radius: 8px;
              object-fit: cover;
            }
          }
        }
      }

      .activity {
        margin: 0 12px 12px;
        // display: flex;
        height: 214px;
        display: grid;
        grid-template-rows: 214px 214px;
        grid-template-columns: 1fr 1fr; /* 创建两列，每列宽度相等 */
        grid-column-gap: 7px;
        .old {
          // height: 100%;
          padding: 10px 6px;
          background: linear-gradient(180deg, #fff9f2 0%, #fffdfc 100%);
          border-radius: 6px;
          border: 1px solid #fef0d8;
          box-sizing: border-box;
          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .logo {
              width: 80px;
              height: 22px;
            }
            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
              line-height: 17px;
              text-align: center;
              font-style: normal;
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
          .list {
            margin-top: 6px;
            .item {
              display: flex;

              &:not(last-child) {
                margin-bottom: 6px;
              }

              img {
                width: 60px;
                height: 48px;
                border-radius: 8px;
                margin-right: 6px;
                flex-shrink: 0;
              }
              .text {
                height: 53px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                p {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #333333;

                  text-align: justify;
                  font-style: normal;
                  display: -webkit-box;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
                .amount {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 14px;
                  font-style: normal;
                  white-space: nowrap;

                  span {
                    color: #ff3b30;
                    font {
                      font-size: 10px;
                    }
                  }
                  del {
                    color: #999999;
                    font-weight: 400;
                    font-size: 11px;
                    line-height: 16px;
                  }
                }
              }
            }
          }
        }
        .clear {
          // height: 100%;
          box-sizing: border-box;
          background: linear-gradient(180deg, #fff5f8 0%, #fffcfb 100%);
          border-radius: 6px;
          border: 1px solid #ffedf2;
          padding: 10px 6px;
          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .logo {
              width: 60px;
              height: 22px;
            }
            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
              line-height: 17px;
              text-align: center;
              font-style: normal;
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
          .sign {
            box-sizing: border-box;
            margin-top: 6px;
            background: url('./images/本期热卖.png');
            background-size: 100% 100%;
            width: 156px;
            height: 18px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 11px;
            color: #fe1f42;
            line-height: 18px;
            padding-left: 64px;
            font-style: normal;
          }
          .list {
            margin-top: 10px;
            .item {
              display: flex;
              margin-bottom: 12px;

              img {
                width: 55px;
                max-height: 68px;
                object-fit: cover;
                margin-right: 4px;
                flex-shrink: 0;
                border-radius: 8px;
              }
              .text {
                p {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 500;
                  font-size: 12px;
                  color: #333333;
                  line-height: 17px;
                  text-align: left;
                  font-style: normal;
                  display: -webkit-box;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                }
                .amount {
                  position: relative;
                  margin-top: 6px;
                  width: 100px;
                  height: 39px;
                  background: url('./images/抢.png');
                  background-size: 100% 100%;
                  .price {
                    display: flex;
                    flex-direction: column;
                    padding: 9px 4px;
                    .des {
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 400;
                      font-size: 10px;
                      color: #ff4d28;
                      line-height: 11px;
                      font-style: normal;
                    }
                    .amt {
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 600;
                      font-size: 14px;
                      color: #ff4d28;
                      line-height: 20px;
                      font-style: normal;
                      font {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 6px;
                        color: #ff4d28;
                        line-height: 8px;
                        font-style: normal;
                      }
                    }
                  }
                  .dashPrice {
                    width: 28px;
                    display: flex;
                    flex-direction: column;
                    position: absolute;
                    top: 4px;
                    right: 25px;
                    text-align: center;
                    .amt {
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 400;
                      font-size: 9px;
                      color: #643102;
                      line-height: 11px;
                      font-style: normal;
                      white-space: nowrap;
                      font {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 6px;
                        color: #643102;
                        line-height: 8px;

                        font-style: normal;
                      }
                    }

                    .des {
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 400;
                      font-size: 8px;
                      color: #653102;
                      line-height: 11px;
                      font-style: normal;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .cert {
        margin: 0 12px 12px;
        height: 296px;
        background: url('./images/特色专场背景.png');
        background-size: 100% 100%;

        .list {
          // padding: 12px;

          .item {
            box-sizing: border-box;
            // width: 176px;
            height: 148px;

            object-fit: cover;
            display: flex;
            justify-content: space-between;
            // padding: 12px 11px;
            box-sizing: border-box;
            padding-top: 42px;
            position: relative;

            &:nth-child(1),
            &:nth-child(2) {
              border-bottom: 1px solid #f5f5f5;
            }
            &:nth-child(2),
            &:nth-child(4) {
              border-left: 1px solid #f5f5f5;
            }

            .title {
              width: 155px;
              height: 18px;
              position: absolute;
              top: 12px;
              left: 11px;
            }
            .section {
              display: flex;
              flex-direction: column;
              // justify-content: center;
              align-items: center;
              flex: 1;
              img {
                max-width: 76px;
                max-height: 55px;
                margin-bottom: 3px;
                vertical-align: middle;
                object-fit: cover;
              }

              p {
                text-align: center;
                white-space: nowrap;
              }
              .amt {
                margin-right: 2px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #fc4316;
                line-height: 20px;
                font-style: normal;
                span {
                  font-size: 12px;
                  font-family: PingFangSC, PingFang SC;
                }
              }
              .dashPrice {
                margin-top: 1px;
                color: #969696;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                line-height: 13px;
                font-style: normal;
              }
            }
          }
        }
      }

      .recommend {
        margin: 0 12px 12px;

        .hd {
          display: flex;
          align-items: center;
          img {
            width: 80px;
            height: 20px;
          }

          span {
            margin-left: 6px;
            font-size: 13px;
            color: #d17c4f;
            line-height: 18px;
          }
        }

        .bd {
          margin-top: 13px;
          display: flex;
          align-items: center;

          .left {
            flex-shrink: 0;
            // width: 172px;
            flex: 1;
            // height: 286px;
            aspect-ratio: 172/286;

            .item {
              position: relative;
              // width: 172px;
              width: 50%;
              // height: 100%;
              aspect-ratio: 172/286;
              // height: 286px;
              // aspect-ratio: 172/286;
              background-image: url('./images/多惠玩_热销_背景.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-position: center;
              border-radius: 8px;
              overflow: hidden;

              .badge {
                position: absolute;
                top: 0;
                left: 0;
                width: 44px;
                height: 20px;
                z-index: 1;
              }

              .cover {
                // width: 172px;
                width: 100%;
                // height: 206px;
                aspect-ratio: 172/206;
                border-radius: 8px;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                }
              }

              .content {
                padding: 11px 8px 0 8px;

                .views {
                  background: #ff1c20;
                  border-radius: 7px;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  height: 14px;
                  font-size: 11px;
                  color: #ffffff;
                  padding: 0 4px;

                  .icon {
                    width: 11px;
                    height: 11px;
                  }
                }

                .title {
                  margin-top: 5px;
                  font-size: 14px;
                  font-weight: var(--bold-value);
                  color: #333333;
                  line-height: 20px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }

                .price {
                  margin-top: 2px;
                  display: flex;
                  align-items: center;

                  .current {
                    font-size: 16px;
                    font-weight: var(--bold-value);
                    color: #ff1c20;
                    line-height: 20px;

                    span {
                      font-size: 11px;
                      color: #ff1c20;
                      line-height: 14px;
                    }
                  }

                  .cost {
                    font-size: 11px;
                    color: #999999;
                    line-height: 12px;
                    text-decoration: line-through;
                  }
                }
              }
            }

            :global {
              .van-swipe__indicators {
                bottom: 22.9vw;

                .van-swipe__indicator {
                  width: 5px;
                  height: 5px;
                  background: #cccccc;
                  border-radius: 9px;

                  &.van-swipe__indicator--active {
                    width: 5px;
                    height: 5px;
                    background: #ff1c20;
                    border-radius: 9px;
                  }
                }
              }
            }
          }

          .right {
            flex: 1;
            position: relative;
            margin-left: 7px;

            img {
              // width: 172px;
              aspect-ratio: 1.24;
              width: 100%;
              // height: 139px;
              object-fit: cover;
              border-radius: 8px;
              &:last-child {
                margin-top: 8px;
              }
            }
          }
        }
      }

      .waterfall {
        margin: 0 12px 12px;

        .title {
          font-size: 18px;
          font-weight: var(--bold-value);
          color: #333333;
          line-height: 25px;
          margin-bottom: 8px;
        }

        .list {
          .item {
            background: #ffffff;
            border-radius: 8px;
            overflow: hidden;

            .cover {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .content {
              padding: 8px;

              .name {
                font-size: 14px;
                font-weight: var(--bold-value);
                color: #333333;
                line-height: 20px;
                display: -webkit-box;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .tags {
                --gap: 8px;
                --margin-top: 8px;
                display: flex;
                flex-wrap: wrap;
                margin-top: calc(var(--gap) - var(--margin-top));

                .tag {
                  margin-top: var(--gap);
                  margin-right: var(--gap);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: #fff4e6;
                  color: #ff960a;
                  padding: 3px 6px;
                  border-radius: 4px;
                  font-size: 12px;
                  line-height: 17px;
                }
              }

              .extra {
                margin-top: 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .price {
                  font-size: 18px;
                  font-weight: var(--bold-value);
                  color: #ff3b30;
                  line-height: 25px;

                  span {
                    font-size: 12px;
                    font-weight: normal;
                    color: #ff3b30;
                    line-height: 17px;
                  }
                }

                .sales {
                  font-size: 12px;
                  color: #b4b4b4;
                  line-height: 17px;
                }
              }
            }
          }
        }
      }
    }
  }

  .adDialog {
    background-color: transparent;
    text-align: center;

    .cover {
      width: 315px;
      height: 444px;
      object-fit: cover;
    }

    .close {
      margin-top: 12px;
      width: 32px;
      height: 32px;
    }
  }
</style>
